import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import {UserVerificationService} from "../../services/user-verification.service";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-httpmode-edit',
  templateUrl: `./httpmode-edit.component.html`,
})
export class HttpmodeEditComponent implements OnInit {

  public isAdmin: boolean = false;
  public inputIsDisable = true;
  public inputIsHidden = false;
  public selectIsDisable = false;
  public selectIsHidden = true;
  public isAdminSubscription: Subscription;
  public allHttpModeOptions: string[] = ['Async', 'Sync', 'Both'];
  public hasError = false;
  public initialValue = [{}];
  public errorMessage;

  private httpMode: string;

  @Input() inputValue;
  @Input() virtId;
  @Output() onChange: EventEmitter<string> = new EventEmitter<string>();

  constructor(private userVerificationService: UserVerificationService, private http: HttpClient) {
    this.isAdminSubscription = userVerificationService.message.subscribe(res => this.isAdmin = res);
  }

  inputOnClick() {
    this.inputIsDisable = false;
    this.hasError = false;
    this.inputIsHidden = true;
    this.selectIsDisable = true;
    this.selectIsHidden = false;
  }

  inputOnSave() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers};
    var url = '';
    var body: any = {};
    url = ApiEndpoints.UPDATE_HTTP_MODE;
    body = {"virtId": this.virtId, "httpMode": this.httpMode};
    this.http.post<any>(url, body, options).subscribe(
        data => {
          this.hasError = false;
          this.initialValue = [{}];
          this.inputValue = this.httpMode;
        },
        error => {
          this.hasError = true;
          this.errorMessage = error._body;
        }
      );

    this.inputIsDisable = true;
    this.inputIsHidden = false;
    this.selectIsDisable = false;
    this.selectIsHidden = true;
  }

  inputOnCancel(inputCheck) {
    this.inputValue = this.httpMode;
    this.inputIsDisable = true;
    this.inputIsHidden = false;
    this.selectIsDisable = false;
    this.selectIsHidden = true;
    this.hasError = false;
    this.initialValue = [{}];
  }

  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ');
  }

  selectedHttpMode(value:any):void {
    this.hasError = false;
    this.httpMode = value.split(",",1)[0];
    this.onChange.emit(this.httpMode);
  }


  ngOnInit() {
    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });
    this.httpMode = this.inputValue;
  }

  ngOnDestroy() {
    this.isAdminSubscription.unsubscribe();
  }
}
